/**
 * Home Feedback BG Slider Previews
 */
let feedbackSwiper = new Swiper('.valuation-swiper', {
    spaceBetween: 0,
    loop: true,
    loopedSlides: 3, //looped slides should be the same
    longSwipes: false,
    allowTouchMove: false,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
})

/**
 * Home Feedback Swiper
 */
let feedbackSwiperPrev = new Swiper('.valuation-thumbs', {
    slidesPerView: 3,
    spaceBetween: 0,
    autoHeight: false,
    centeredSlides: true,
    loop: true,
    allowTouchMove: false,
    loopedSlides: 3, //looped slides should be the same
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
})

/**
 * Office and Service Swiper
 */
let officeSwiper = new Swiper('.swiper-office-values', {
    spaceBetween: 0,
    slidesPerView: 1,
    autoHeight: false,
    centeredSlides: true,
    loop: true,
    longSwipes: false,
    pagination: {
        el: '.values-pagination',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    }
})

/**
 * Office Images Swiper
 */
let galleryThumbs = new Swiper('.gallery-thumbs', {
    slidesPerView: 3,
    spaceBetween: 0,
    autoHeight: false,
    centeredSlides: true,
    loopedSlides: 4, //looped slides should be the same
    loop: true,
    allowTouchMove: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
})

/**
 * Office Image BG Slider Previews
 */
let galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 0,
    loop: true,
    loopedSlides: 4, //looped slides should be the same
    autoHeight: false,
    centeredSlides: true,
    longSwipes: false,
    allowTouchMove: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
})

/**
 * Blog Images Swiper
 */
let blogSwiper = new Swiper('.blog-thumbs', {
    slidesPerView: 1,
    spaceBetween: 8,
    autoHeight: false,
    centeredSlides: true,
    loop: true,
    allowTouchMove: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    // Responsive breakpoints
    breakpointsInverse: true,
    breakpoints: {
        960: {
            slidesPerView: 2,
            spaceBetween: 10
        },
        1140: {
            slidesPerView: 3,
            spaceBetween: 10
        }
    }
})


/**
 * Trigger Functions between Office Main and Background Swiper
 */

let swiperThumbs = document.getElementById('gallery-thumbs')
if (swiperThumbs != null) {
    swiperThumbs = swiperThumbs.swiper
    swiperThumbs.on('slideNextTransitionStart', function () {
        //console.log('next thumb');
    })
}

let swiperGallery = document.getElementById('gallery-top')
if (swiperGallery != null) {
    swiperGallery = swiperGallery.swiper
    swiperGallery.on('slideNextTransitionStart', function () {
        swiperThumbs.slideNext();
    })
    swiperGallery.on('slidePrevTransitionStart', function () {
        swiperThumbs.slidePrev();
    })
}

/**
 * Trigger Functions between Feedback Main and Background Swiper
 */
let valuationThumbs = document.getElementById('valuation-thumbs')
if (valuationThumbs != null) {
    valuationThumbs = valuationThumbs.swiper
    valuationThumbs.on('slideNextTransitionStart', function () {
        valuationSwiper.slideNext();
    })
    valuationThumbs.on('slidePrevTransitionStart', function () {
        valuationSwiper.slidePrev();
    })
}

let valuationSwiper = document.getElementById('valuation-swiper')
if (valuationSwiper != null) {
    valuationSwiper = valuationSwiper.swiper

}
